import actionTypes from './actionTypes';

export const retrieveInventoryAssets = data => ({
  type: actionTypes.REQUEST_INVENTORY_ASSETS,
  data,
});

export const getInventoryAssetsSuccess = data => ({
  type: actionTypes.GET_INVENTORY_ASSETS_SUCCESS,
  data,
});

export const getInventoryAssetsFailure = () => ({
  type: actionTypes.GET_INVENTORY_ASSETS_FAILURE,
});

export const retrieveInventoryAssetsFilter = data => ({
  type: actionTypes.REQUEST_INVENTORY_ASSETS_FILTER,
  data,
});

export const getInventoryAssetsFilterSuccess = data => ({
  type: actionTypes.GET_INVENTORY_ASSETS_FILTER_SUCCESS,
  data,
});

export const getInventoryAssetsFilterFailure = () => ({
  type: actionTypes.GET_INVENTORY_ASSETS_FILTER_FAILURE,
});

export const requestRootAssetBatchCreateFHWA = data => ({
  type: actionTypes.REQUEST_ROOT_ASSET_BATCH_CREATE_FHWA,
  data,
});

export const createRootAssetBatchFHWASuccess = (data?: object) => ({
  type: actionTypes.CREATE_ROOT_ASSET_BATCH_FHWA_SUCCESS,
  data,
});

export const createRootAssetBatchFHWAFailure = () => ({
  type: actionTypes.CREATE_ROOT_ASSET_BATCH_FHWA_FAILURE,
});

export const requestRootInventoryAssetDeletion = data => ({
  type: actionTypes.REQUEST_ROOT_INVENTORY_ASSET_DELETION,
  data,
});

export const rootInventoryAssetDeletionSuccess = data => ({
  type: actionTypes.ROOT_INVENTORY_ASSET_DELETION_SUCCESS,
  data,
});

export const rootInventoryAssetDeletionFailure = data => ({
  type: actionTypes.ROOT_INVENTORY_ASSET_DELETION_FAILURE,
  data,
});

export const requestFhwaElementDeletion = data => ({
  type: actionTypes.REQUEST_FHWA_ELEMENT_DELETE,
  data,
});

export const deleteFhwaElementSuccess = () => ({
  type: actionTypes.DELETE_FHWA_ELEMENT_SUCCESS,
});

export const deleteFhwaElementFailure = () => ({
  type: actionTypes.DELETE_FHWA_ELEMENT_FAILURE,
});
